// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5608) return "static/chunks/5608-5211b6db3357ebfb.js";
	if (chunkId === 9334) return "static/chunks/9334-3f20346fced2ee02.js";
	if (chunkId === 3850) return "static/chunks/3850-69678ef8a2030b20.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3450":"bf9de634431060c3","7480":"896286794e1db9df","8765":"0123e200695f05e2","9707":"51e391001dd9f1e2","9920":"0314e6c58c8aa95c"}[chunkId] + ".js";
};